"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceFocusAudioWorkletNode = void 0;
class VoiceFocusAudioWorkletNode extends (globalThis['AudioWorkletNode'] || class Sadness {
}) {
}
exports.VoiceFocusAudioWorkletNode = VoiceFocusAudioWorkletNode;
